import React from 'react'

var EventBanner = React.createClass({
  propTypes: {
    src: React.PropTypes.string
  },
  render: function() {
    const { src } = this.props;
    return(
      <div className="row">
        <div className="col-sm-offset-2 col-sm-8">
          { !src ? undefined :
            <img src={'/uploads/events/banners/'+src} className="img-responsive event-logo" />
          }
        </div>
      </div>
    );
  }
});

export default EventBanner;


// WEBPACK FOOTER //
// ./src/components/event_banner.js